var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28437 0.219375L4.19438 3.12938L7.10437 0.219375C7.39687 -0.073125 7.86937 -0.073125 8.16187 0.219375C8.45438 0.511875 8.45438 0.984375 8.16187 1.27688L4.71937 4.71938C4.42687 5.01188 3.95437 5.01188 3.66187 4.71938L0.219375 1.27688C-0.073125 0.984375 -0.073125 0.511875 0.219375 0.219375C0.511875 -0.065625 0.991875 -0.073125 1.28437 0.219375Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.1dff78de6cbed80d48c1b0f8930a74df.svg";
export { ForwardRef as ReactComponent };